import { jsxs as t, jsx as c } from "react/jsx-runtime";
import { H as h, f as n, m as f } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as u } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as a } from "../BaseIcon/index.js";
import { FieldDescription as _ } from "../FieldDescription/index.js";
import { FieldError as p } from "../FieldError/index.js";
import { FieldLabel as b } from "../FieldLabel/index.js";
import { Input as F } from "../Input/index.js";
import '../../assets/index21.css';const I = "_inputStack_1cnnq_1", S = "_decoration_1cnnq_7", q = "_clearButton_1cnnq_17", x = "_searchIcon_1cnnq_27", $ = "_searchField_1cnnq_36", z = "_horizontal_1cnnq_77", B = "_fullWidth_1cnnq_97", o = {
  inputStack: I,
  decoration: S,
  clearButton: q,
  searchIcon: x,
  searchField: $,
  horizontal: z,
  fullWidth: B
};
function L({
  label: i,
  description: l,
  errorMessage: s,
  fullWidth: d = !1,
  horizontal: r = !1,
  placeholder: m = "Search",
  ...e
}) {
  return /* @__PURE__ */ t(
    h,
    {
      ...u(e),
      className: n(o.searchField, {
        [o.fullWidth]: d || r,
        [o.horizontal]: r
      }),
      "data-component": "SearchField",
      children: [
        /* @__PURE__ */ c(b, { children: i }),
        /* @__PURE__ */ t("div", { className: o.inputStack, children: [
          /* @__PURE__ */ c("div", { className: n(o.decoration, o.searchIcon), "aria-hidden": !0, children: /* @__PURE__ */ c(a, { icon: "search", size: "sm" }) }),
          /* @__PURE__ */ c(
            F,
            {
              autoComplete: "off",
              placeholder: m,
              "aria-label": e["aria-label"],
              onInput: e.onInput,
              value: e.value
            }
          ),
          /* @__PURE__ */ c(f, { className: n(o.decoration, o.clearButton), children: /* @__PURE__ */ c(a, { icon: "close", size: "sm", color: "moon" }) })
        ] }),
        /* @__PURE__ */ c(_, { children: l }),
        /* @__PURE__ */ c(p, { children: s })
      ]
    }
  );
}
export {
  L as SearchField
};
//# sourceMappingURL=index.js.map
